const MIN_SCORE = 1;
const MAX_SCORE = 5;

function clampScore(value: number): number {
  return Math.min(MAX_SCORE, Math.max(MIN_SCORE, Math.trunc(value)));
}

export function computeSwotIndex(severity: number, occurrence: number, control: number): number {
  return clampScore(severity) * clampScore(occurrence) * clampScore(control);
}

export function computePartySeverity(interestScore: number, powerScore: number): number {
  return Math.round((clampScore(interestScore) + clampScore(powerScore)) / 2);
}

export function computePartyIndex(
  severity: number,
  occurrence: number,
  detection: number,
): number {
  return clampScore(severity) * clampScore(occurrence) * clampScore(detection);
}

export const SCORE_OPTIONS = [1, 2, 3, 4, 5] as const;
